/**
 * ErrorModal - Pre-configured modal for error messages
 *
 * Red/warning themed modal for displaying errors.
 * Supports optional secondary action button (e.g., "Apply for Access").
 */

import { Modal } from './Modal'

interface ErrorModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  message: string | React.ReactNode
  buttonText?: string
  /** Optional secondary action button (e.g., "Apply for Access") */
  secondaryAction?: {
    label: string
    onClick: () => void
  }
}

export function ErrorModal({
  isOpen,
  onClose,
  title = 'Error',
  message,
  buttonText = 'Try Again',
  secondaryAction
}: ErrorModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} showCloseButton={false}>
      {/* Error Icon */}
      <div className="text-center mb-4">
        <div className="text-6xl">💌</div>
      </div>

      {/* Title */}
      <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
        {title}
      </h2>

      {/* Message */}
      <p className="text-gray-600 text-center mb-6">
        {message}
      </p>

      {/* Buttons */}
      <div className="space-y-3">
        {/* Primary Close Button */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-pink-600 text-white rounded-lg font-medium shadow-sm hover:bg-pink-700 transition-colors"
        >
          {buttonText}
        </button>

        {/* Secondary Action Button (optional) */}
        {secondaryAction && (
          <button
            onClick={secondaryAction.onClick}
            className="w-full py-3 border-2 border-pink-600 text-pink-600 rounded-lg font-medium hover:bg-pink-50 transition-colors"
          >
            {secondaryAction.label}
          </button>
        )}
      </div>
    </Modal>
  )
}
